function checkIfDarkTheme(el = document.body) {
  const backgroundInvertIfDark = window.getComputedStyle(el).getPropertyValue("--background-invert-if-dark");
  if (backgroundInvertIfDark !== void 0) {
    return backgroundInvertIfDark === "invert(100%)";
  }
  return false;
}
const isDarkTheme = checkIfDarkTheme();
export {
  checkIfDarkTheme,
  isDarkTheme
};
//# sourceMappingURL=isDarkTheme.mjs.map
